import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabelModule } from 'primeng/floatlabel';
import { UserService } from '../../../services/user.service';
import { PhonePipe } from '../../../pipes/phone.pipe';

@Component({
  selector: 'brt-user-selector',
  standalone: true,
  imports: [CommonModule, AutoCompleteModule, FloatLabelModule, PhonePipe],
  templateUrl: './user-selector.component.html',
  styleUrl: './user-selector.component.css'
})
export class UserSelectorComponent {
  private userService = inject(UserService)

  @Output() onSelectionChanged = new EventEmitter<any|undefined>();

  users: any[];
  async searchUser(query: string) {
    this.users = (await this.userService.search({ Query: query })).List;
  }


}
